import { useCallback, useEffect, useRef, useState } from 'react'
import { DescendantRow } from '../../../../domain/value-object/ProjectPlanSnapshot'
import { useProjectPlanSnapshotRepository } from '../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'

export type UseDeliverableTaskSnapshotReturnValue = ReturnType<
  typeof useDeliverableTaskSnapshot
>

/** 内訳の取り方。DESCENDANTS は行の配下すべて、TICKETS はチケット管理表に属するチケット */
export type DrilldownSource = 'DESCENDANTS' | 'TICKETS'

export const useDeliverableTaskSnapshot = (snapshotUuid: string) => {
  const { fetchDescendantsByRoot, fetchTicketsByTicketList } =
    useProjectPlanSnapshotRepository()
  const cacheRef = useRef<Map<string, DescendantRow[]>>(new Map())
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    cacheRef.current = new Map()
  }, [snapshotUuid])

  const fetch = useCallback(
    async (rootUuid: string, source: DrilldownSource) => {
      // 同じ行でも取り方で中身が変わる（チケット別進捗状況はチケットと配下のタスクを切り替える）
      const cacheKey = `${source}:${rootUuid}`
      const cached = cacheRef.current.get(cacheKey)
      if (cached) return cached
      setLoading(true)
      try {
        const result =
          source === 'TICKETS'
            ? await fetchTicketsByTicketList(snapshotUuid, rootUuid)
            : await fetchDescendantsByRoot(snapshotUuid, rootUuid)
        cacheRef.current.set(cacheKey, result)
        return result
      } catch (error) {
        console.error('Failed to fetch descendants:', error)
        throw error
      } finally {
        setLoading(false)
      }
    },
    [snapshotUuid, fetchDescendantsByRoot, fetchTicketsByTicketList]
  )

  return { fetch, loading }
}
